import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class CommandService
{
    private readonly compactSubject = new BehaviorSubject<boolean>(false);

    readonly compactMode: Observable<boolean>;

    constructor()
    {
        this.compactMode = this.compactSubject.asObservable();
    }

    setCompactMode(mode: boolean): void
    {
        this.compactSubject.next(mode);
    }
}
